import moment from "moment";

export const getCommaSeparatedNumber = (amount) => {
    return new Intl.NumberFormat("en-US").format(amount);
};

export const hasData = (obj) => Boolean(Object.keys(obj).length);

export const getFormattedAmountWithCurrency = (amount, currency = "AED") => {
    const formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: currency || "USD",
        minimumFractionDigits: 0
    });
    return formatter.format(amount);
};

export const escapeHTMLElementsFromMessage = (message) => {
    //todo places in util helper
    var htmlEscapes = {
        "<": "&lt;",
        ">": "&gt;"
    };
    // Regex containing the keys listed immediately above.
    var htmlEscaper = /[<>]/g;
    // Escape a string for HTML interpolation.
    return message.replace(htmlEscaper, function (match) {
        return htmlEscapes[match];
    });
};

export const getObjectByKeys = (arr, key = "Id", deleteKey = null, addKeys = null) => {
    let obj = {};
    arr.forEach((val) => {
        obj[val[key]] = val;
        if (deleteKey) {
            delete obj[val[key]][deleteKey];
        }
        if (addKeys) {
            obj[val[key]] = {
                ...obj[val[key]],
                ...addKeys
            };
        }
    });
    return obj;
};

export const getIdsFromData = (data, key = "Id") => {
    return data.map((item) => item[key]);
};

export const objectContainsKey = (object, key) => {
    return typeof object === "object" && object && object[key] !== undefined;
};

export const getPhoneNumber = (data) => {
    if (data && data.CountryCode && data.PhoneNumber) {
        return `${data.CountryCode} ${data.PhoneNumber}`;
    }
    return "-";
};

export const prepareTableColumnState = (columnData) => {
    let obj = {};
    Object.keys(columnData).forEach((key) => {
        obj[columnData[key]] = {
            title: columnData[key],
            isShown: true
        };
    });

    return obj;
};

export const getObjectFromKeyValue = (
    arr = [],
    key = "",
    subKey = "",
    getValueKey = "",
    value = ""
) => {
    if (!arr?.length) return;
    if (!arr.find((item) => item[key]).length) return;

    return arr.find((item) => item[key][subKey] == value)[getValueKey];
};

export const removeDuplicatValFromArray = (arr) => {
    if (!arr.length) {
        return;
    }

    return [...new Set(arr)];
};

export const replaceStrings = (str, keyToFind, keysToReplaceObj = {}) => {
    return str.replace(keyToFind, (matched) => {
        return keysToReplaceObj[matched];
    });
};

export const truncateString = (string = "", maxLength) => {
    if (!string || !maxLength) return
    return string.length > maxLength
      ? `${string.substring(0, maxLength)}…`
      : string
  }

  export const removeSpaceUnderscoreCharacterFromString = (str = "") => {
    if (!str) return;
    let data = str;
    let newStr = data.replace(/[^a-zA-Z.1-9]/g, ""); // remove non-letter characters, except period
    return `${newStr}`;
};

export const getApiFetch = async (loaderUpdateHandler, dataupdateHandler, requestFn, id, params={}) => {
    loaderUpdateHandler(true);
    const res = id ? await requestFn(id) : await requestFn(params);
    dataupdateHandler(res);
    loaderUpdateHandler(false);
}

export const findOutDateToDisplay = (dateInYears, dateInMonths, dateInDays) => {
    let finalDateToDisplay;
    let allConditionsEmpty = !dateInYears  &&  !dateInMonths  && !dateInDays ;

    if(allConditionsEmpty){
        finalDateToDisplay = `${dateInYears} Years`
    }else if(!dateInYears && !dateInMonths){
        finalDateToDisplay = `${dateInDays} Days`
    }else if(!dateInYears){
        finalDateToDisplay = `${dateInMonths} Months`
    }else {
        finalDateToDisplay = `${dateInYears} Years`
    }
    return finalDateToDisplay;
}

export const findOutAgeFromDate = (dob) => {
    console.log('dobdob', dob)
    if(dob == null || !dob){
        return dob;
    }
    const dateOfBirthYears = moment().diff(dob, 'years');
    const dateOfBirthMonths = moment().diff(dob, 'months');
    const dateOfBirthDays = moment().diff(dob, 'days');
    return findOutDateToDisplay(dateOfBirthYears,dateOfBirthMonths,dateOfBirthDays)
}